module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "progress-table",
    attrs: {
      "table-ref": "progesstable",
      "title": _vm.permitLabel + ' Report',
      "icon": "fa fa-file",
      "url": "/view/actions/prg",
      "fields": _vm.fields,
      "sort-field": "siteName",
      "detail-component": "progress-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f8982f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/progress/ProgressReport.vue
// module id = 1616
// module chunks = 0